// extracted by mini-css-extract-plugin
export default {"row":"DrawDate_row__etSJL","label":"DrawDate_label__0qC9o","prizeTime":"DrawDate_prizeTime__YeAuh","date":"DrawDate_date__T5ihz","subtext":"DrawDate_subtext__bVsUj"};